/**
 * Loại
 * bdanh 05.02.2023
 */
export default {
  RevenuePricingGovernment: 1,
  RevenueOtherServices: 3,
  RevenueOrderOfGovernment: 2,
};
